export { default } from 'Components/ScrollableProductList/ScrollableProductList'
